import { useListItemDataProvider } from "@circle-react-shared/uikit/SortableList";
import { CommunitySection } from "./CommunitySection";

export const CommunityDragOverlay = () => {
  const { item: community }: any = useListItemDataProvider();
  return <CommunitySection community={community} token="" index={0} />;
};
